import { Component, NgZone, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import {FreeService} from '../../../_services/free.service';


@Component({
  selector: 'app-free-home',
  templateUrl: './free-home.component.html',
  styleUrls: ['./free-home.component.css'],
  providers: [FreeService , AdvtService ],
})
export class FreeHomeComponent implements OnInit {
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('template_new') template_new: TemplateRef<any>;
  @ViewChild('template_seller') template_seller: TemplateRef<any>;

  type = 'free';
  // Modal
  modalRef: BsModalRef;

  public listItem;
  public listSingleItem;
  category_id = 8;
  public seller_id;
  pageSize = 9;
  pageNo = 1;
  totalPage = [1];
  del = false;
  public searchSubmit = false;
  listLength: any;
  loading: Boolean = false;
  mainLoader;
  NAP;
  is_seller;
  is_seller_status: Boolean = false;
  item_id;
  delete_model = false;
  modal_message;
  dismesUp: Boolean = false;
  showButton: Boolean = false;

  distance_type= "";
  distance="";
  searchKeyword="";
  longitude;
  latitude;
  userInfo = JSON.parse(localStorage.getItem('currentUser'));
  user_id = this.userInfo.result.id;
  tradeSearch;
  tradeCount;
  titleSearch;
  type2 = 'freeHome';


  constructor(private fb: FormBuilder,
              private advtService: AdvtService,
              private freeService: FreeService,
              private alertService: AlertService,
              private modalService: BsModalService,
              private router: Router,
              private http: Http) {
  }


  ngOnInit() {
    if (localStorage.getItem('currentMenu')) {
      localStorage.removeItem('currentMenu');
      localStorage.setItem('currentMenu', 'tradeHome');
    }
    window.scrollTo(0, 0);
    this.mainLoader = '../../assets/images/BigLoader.gif';
    this.NAP = '../../assets/images/nap.jpg';

    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.seller_id = userInfo.result.id;
      this.is_seller = userInfo.result.is_seller;
    }
    this.setCurrentPosition();
    /*  let a = 'noSearch';
      setTimeout(() => {
        this.searchTrade(a);
      }, 1000);*/
  }

  /**
   *
   *function to open model
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
    // if (this.delete_model == false) {
    //   let item_id = id;
    //   this.advtService.getSingleItem(this.seller_id, item_id)
    //     .subscribe(data => {
    //       this.listSingleItem = data;
    //     }, error => {
    //       this.alertService.error(error);
    //     });
    // }
  }

  /**
   *
   *function to open model
   */
  openModalseller(template_seller: TemplateRef<any>, id) {
    this.modalRef = this.modalService.show(
      template_seller,
      Object.assign({}, { class: 'gray modal-md' })
    );
    //if (this.delete_model == false) {
    let item_id = id;
    this.advtService.getSingleItem(this.seller_id, item_id)
      .subscribe(data => {
        this.listSingleItem = data;
      }, error => {
        this.alertService.error(error);
      });
    // }
  }

  showModal(){
    this.openModal(this.template)
  }

  public searchFree(modeType){
    this.loading = true;
    let json ={
      current_lat :this.latitude,
      current_lng : this.longitude,
      offset:0,
      limit:9,
      category :this.category_id,
      seller_id :this.user_id,
      distance_type :this.distance_type,
      keywords:this.searchKeyword,
      search:this.titleSearch,
      distance: this.distance
    }
    // localStorage.setItem('last_search',json);

    this.freeService.searchFreeProduct(json).subscribe(data => {
      if(data.count!=0){
        this.listItem = data.result;
        this.listLength = data.count;
        if(modeType == "search"){
          // this._hidemodal();
        }
      }else{
        this.openModal(this.template_new)
      }

      this.loading = false;
    }, error => {
      this.alertService.error(error);
    });
  }

  saveSearch(){
    this.loading = true;
    // const params = {
    //   current_lat: this.lat ? this.lat : '',
    //   current_lng: this.long ? this.long : '',
    //   keywords: this.keyword ? this.keyword : null,
    //   radius: this.distance ? this.distance : '25',
    //   distance_type: this.distance_type ? this.distance_type : 'mi',
    //   category: this.category ? this.category : '',
    //   escrow_service: this.escrow_service ? this.escrow_service : null,
    //   seller_id: this.currentUser ? this.currentUser.id : ''
    // };

    let json ={
      current_lat :this.latitude,
      current_lng : this.longitude,

      category :this.category_id,
      seller_id :this.user_id,
      distance_type : this.distance_type ? this.distance_type : 'mi',
      keywords:this.searchKeyword,
      radius:  this.distance ? this.distance : '25',
    }
    this.advtService.saveData(json).subscribe((data) => {
      this.loading = false;
      if(data.status == 200){
        //  this._hidemodal();
        this._hidemodal();
      }
    });
  }



  /**
   * This function is used for pagination
   * @param data
   */
  pagingAgent(data) {
    this.loading = true;
    this.listItem = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;
    let json ={
      current_lat :this.latitude,
      current_lng : this.longitude,
      offset:this.pageNo,
      limit:this.pageSize,
      category :this.category_id,
      seller_id :this.user_id,
      distance_type :this.distance_type,
      keywords:this.searchKeyword,
      search:this.titleSearch,
      distance: this.distance
    }
    this.listItem = [];
    this.advtService.searchTrade(json)
      .subscribe(data => {
        window.scrollTo(0, 0);
        this.listItem = data.result;
        this.loading = false;

      });
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  public _hidemodal() {
    this.modalRef.hide();

  }

  /**
   * function to cancel popup
   */
  public disposePop() {
    this._hidemodal();
  }

  /**
   * function to get current position
   */
  private setCurrentPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
  }

  _checkNumPattern(event: any) {
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }
    if (event.which === 48 && event.target.selectionStart === 0) {
      return false;
    }
  }

  public checkSeller(id) {
      this.router.navigate(['./free/free-add', 0 ,'noitem']);
    
  }

  public makeSeller() {
    this.loading = true;
    this.advtService.makeSeller(this.seller_id).subscribe((res) => {
      if (res.status === 200) {
        if(res['redirect_to_stripe'] == 1){
          window.location.href = environment.stripeurl+res['result']['id'];
        }else{
          this.router.navigate(['./trade/trade-add', 0 ,'noitem']);
        }
        this.loading = false;

        if(res['show_message']){
          this.dismesUp = true;
          this.modal_message = res['message'];
          this.showButton = true;
        }else{
          /*this.router.navigate(['./trade/trade-add', 0 ,'noitem']);
          this._hidemodal();
          let resUpdated = JSON.parse(localStorage.getItem('currentUser'));
          resUpdated.result.is_seller = 1;
          localStorage.removeItem("currentUser");
          localStorage.setItem("currentUser", JSON.stringify(resUpdated));*/
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/free/free-home/free-home.component.ts